<template>
  <NavBar />
  <router-view v-slot="{ Component }">
    <transition name="page" mode="out-in">
      <Component :is="Component"></Component>
    </transition>
  </router-view>
  <v-sheet
    class="d-none d-md-block alert-screen"
    v-if="!$route.meta.hideNavBar"
  >
    <img
      src="./assets/logo.png"
      width="180"
      alt="logo"
      style="margin-top: 15%"
    />
    <div class="text-h4 text-green-lighten-1 my-2">
      .عذراً تطبيق كن ايجابي متوفر حالياً للهواتف فقط
    </div>
  </v-sheet>
  <div class="logo">
    <img src="./assets/logo.png" class="w-50 mr-5" alt="" />
  </div>
  <footer v-if="!$route.meta.hideNavBar" class="mt-10" style="overflow: hidden">
    <p class="text-h6 font text-black">زورونا على مواقع التواصل</p>
    <v-row>
      <v-col cols="12"
        ><a
          class="mx-3 text-decoration-none"
          href="https://t.me/bepositive12"
          target="_blank"
        >
          <img
            src="./assets/icons/telegram-48.png"
            class="mt-2"
            alt="telegram logo"
            width="40" /></a
        ><a
          class="mx-3 text-decoration-none"
          href="https://www.facebook.com/profile.php?id=100069137751823"
          target="_blank"
        >
          <img
            src="./assets/icons/facebook.png"
            class="mt-2"
            alt="facebook logo"
            width="38" /></a
      ></v-col>
    </v-row>
    <h4 class="w-100 mx-auto font" style="color: #42b983">
      &copy; جميع الحقوق محفوظة لدى كن ايجابي
    </h4>
  </footer>
</template>
<script>
import NavBar from "./components/NavBar.vue";
export default {
  components: {
    NavBar,
  },
  mounted() {
    window.onload = setTimeout(() => {
      document.querySelector(".logo").style.opacity = 0;
    }, 700);
    window.onload = setTimeout(() => {
      document.querySelector(".logo").style.display = "none";
    }, 1000);
  },
};
</script>

<style>
/*  خط القران */
@font-face {
  font-family: "Hafs";
  src: url("./assets/font/Hafs.ttf");
}
/* الخط العادي */
@import url("https://fonts.googleapis.com/css2?family=Vazirmatn:wght@100..900&display=swap");

/*  خط ترقيم القران */
@import url("https://db.onlinewebfonts.com/c/facda43bfb0cbd270ecd3a212082a754?family=ArabicTwo");
.font {
  font-family: "Vazirmatn", sans-serif !important;
  font-weight: 400 !important;
}
.font-quran {
  font-family: "Hafs", sans-serif !important;
}
.ar-numbers {
  font-family: "ArabicTwo";
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.logo {
  min-width: 100%;
  min-height: 100%;
  background-color: #ffff;
  position: absolute;
  top: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
  transition: opacity ease-in-out 0.5s;
}

/* */
.alert-screen {
  min-width: 100%;
  min-height: 100%;
  background-color: #ffff;
  position: fixed;
  top: 0;
  z-index: 120;
  display: flex;
  flex-direction: column;
  align-items: center !important;
  justify-content: center !important;
}
/* */
nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.page-enter-from,
.page-leave-to {
  transform: translateX(20px) !important;
  opacity: 0 !important;
}
.page-enter-active,
.page-leave-active {
  transition: all 0.3s ease-out !important;
}
</style>
